module.exports = __webpack_public_path__ + "static/media/grid_rainy.b3c67aa7.svg";